import type { ConcedeCommand, MatchState } from "../../../../schemas"
import type { CommandResult } from "../state"
import { appendLog, err, getOtherSeatId } from "../state"

export function handleConcede(
  state: MatchState,
  cmd: ConcedeCommand,
): CommandResult {
  if (state.status === "completed") {
    return err("CONCEDE_MATCH_OVER", "Match is already completed.")
  }

  const winnerId = getOtherSeatId(cmd.seatId)

  let s = appendLog(state, cmd.seatId, "concede", { seatId: cmd.seatId })

  s = {
    ...s,
    status: "completed",
    result: {
      winnerSeat: winnerId,
      loserSeat: cmd.seatId,
      reason: "concede",
      finalTurn: state.turn.number,
    },
  }

  return { ok: true, state: s }
}
